import { render, staticRenderFns } from "./OccupationClass.vue?vue&type=template&id=7cb6e975&"
import script from "./OccupationClass.vue?vue&type=script&lang=js&"
export * from "./OccupationClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports